import { render, staticRenderFns } from "./CandidatesAllPage.vue?vue&type=template&id=2c6f4865&scoped=true&lang=pug"
import script from "./CandidatesAllPage.vue?vue&type=script&lang=js"
export * from "./CandidatesAllPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesAllPage.vue?vue&type=style&index=0&id=2c6f4865&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f4865",
  null
  
)

export default component.exports